import React,{ Component } from 'react';
import {Button, Modal, Table} from "antd";

const columnsF=[
    {
        title: 'Invoice#',
        dataIndex: 'invoiceNumber',
    },
    {
        title: 'Upload Result',
        dataIndex: 'checkFlag',
        render:(text)=>{
            return text?'Validation OK':'Error'
        }
    },
    {
        title: 'Error Massage',
        dataIndex: 'checkMessage',
    },
]
const columnsP=[
    {
        title: 'Invoice#',
        dataIndex: 'invoiceNumber',
    },
    {
        title: 'Part Number',
        dataIndex: 'partNumber',
    },
    {
        title: 'Upload Result',
        dataIndex: 'checkFlag',
        render:(text)=>{
            return text?'Validation OK':'Error'
        }
    },
    {
        title: 'Error Massage',
        dataIndex: 'checkMessage',
    },
]
const columnsSN=[
    {
        title: 'Serial Number',
        dataIndex: 'serialNumbers',
    },
    {
        title: 'Invoice#',
        dataIndex: 'invoiceNumber',
    },
    {
        title: 'Part Number',
        dataIndex: 'partNumber',
    },
    {
        title: 'Upload Result',
        dataIndex: 'checkFlag',
        render:(text)=>{
            return text?'Validation OK':'Error'
        }
    },
    {
        title: 'Error Massage',
        dataIndex: 'checkMessage',
    },
]
class MassModel extends Component{
    deWeightThree = () => {
        let map =new Map();
        for (let item of this.props.data) {
            if(!map.has(item.invoiceNumber)) {
                map.set(item.invoiceNumber, item);
            }
        }
        return [...map.values()];
    }
    onMassUpload=()=>{
        let data=[];
        this.props.data.forEach(item=>{
            if(item.checkFlag){
                data.push({...item,id:''})
            }
        })
        this.props.MassUploadData(data)
        this.props.onCancel()
    }
    checkColumns=()=>{
        let {full_invoice_Claim_Checked,the_whole_invoice_claim,type,flag} = this.props;
        if(flag==='WEP'){
            if(type===6 && full_invoice_Claim_Checked ||
                type===2 && full_invoice_Claim_Checked ||
                type===13 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===3 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===10 && full_invoice_Claim_Checked ||
                type===8 && full_invoice_Claim_Checked  ||
                type===11 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===5 && full_invoice_Claim_Checked && !the_whole_invoice_claim
            ){
                return  'columnsP'
            }else if(type===1 && full_invoice_Claim_Checked ||
                type===4 && full_invoice_Claim_Checked ||
                type===13 && the_whole_invoice_claim ||
                type===3 && the_whole_invoice_claim  ||
                type===11 && the_whole_invoice_claim ||
                type===5 && the_whole_invoice_claim
            ){
                return 'columnsF'
            }else if(type===7 && full_invoice_Claim_Checked){
                return  'columnsSN'
            }
        }else if(flag==='WED'){
            if(type===14 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===13 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===3 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===11 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===5 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===2 && full_invoice_Claim_Checked ||
                type===10 && full_invoice_Claim_Checked
            ){
                return 'columnsP'
            }else if(type===14 && the_whole_invoice_claim ||
                type===13 && the_whole_invoice_claim ||
                type===3 && the_whole_invoice_claim ||
                type===11 && the_whole_invoice_claim ||
                type===5 && the_whole_invoice_claim ||
                type===1 && full_invoice_Claim_Checked ||
                type===4 && full_invoice_Claim_Checked
            ){
                return 'columnsF'
            }else if(type===7 && full_invoice_Claim_Checked){
                return  'columnsSN'
            }
        }else if(flag==='EMP'){
            if(type===1 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===12 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===7 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===5 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===4 && full_invoice_Claim_Checked ||
                type===6 && full_invoice_Claim_Checked
            ){
                return 'columnsP'
            }else if(type===1 && the_whole_invoice_claim ||
                type===2 && full_invoice_Claim_Checked ||
                type===3 && full_invoice_Claim_Checked ||
                type===12 && the_whole_invoice_claim ||
                type===7 && the_whole_invoice_claim ||
                type===5 && the_whole_invoice_claim
            ){
                return 'columnsF'
            }else if(type===8 && full_invoice_Claim_Checked){
                return 'columnsSN'
            }
        }else if(flag==='EMD'){
            if(type===1 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===11 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===7 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===5 && full_invoice_Claim_Checked && !the_whole_invoice_claim ||
                type===4 && full_invoice_Claim_Checked ||
                type===6 && full_invoice_Claim_Checked
            ){
                return 'columnsP'
            }else if(type===14 && !the_whole_invoice_claim && full_invoice_Claim_Checked ||
                type===1 && full_invoice_Claim_Checked ||
                type===2 && full_invoice_Claim_Checked ||
                type===3 && full_invoice_Claim_Checked ||
                type===7 && the_whole_invoice_claim ||
                type===11 && the_whole_invoice_claim ||
                type===5 && the_whole_invoice_claim
            ){
                return 'columnsF'
            }else if(type===8 && full_invoice_Claim_Checked){
                return 'columnsSN'
            }
        }
    }

    render(){
        return <Modal width={1200} title="Mass Upload Validation Result Confirm"
                      visible={this.props.ModalVisible}
                      onOk={this.props.handleOk}
                      onCancel={this.props.onCancel}
                      destroyOnClose={true}
                      footer={[
                          <Button type="primary" onClick={this.onMassUpload}>
                              Yes
                          </Button>,
                          <Button onClick={this.props.handleOk}>
                              No
                          </Button>,
                      ]}
        >
            <Table
                scroll={{ x: 1500 ,y: 500}}
                rowKey={'id'}
                columns={this.checkColumns()==='columnsP'?columnsP:this.checkColumns()==='columnsF'?columnsF:this.checkColumns()==='columnsSN'?columnsSN:''}
                dataSource={this.checkColumns()==='columnsF'?this.deWeightThree():this.props.data}
            />
        </Modal>
    }

}

export default MassModel;